import step1 from '../../../../sections/assets/1.jpg'
import step2 from '../../../../sections/assets/2.jpg'
import step3 from '../../../../sections/assets/3.jpg'
import step4 from '../../../../sections/assets/4.jpg'
import step5 from '../../../../sections/assets/5.jpg'

export const HOW_IT_WORKS_SECTION = {
  heading: 'Our 5 easy steps to a food box delivery',
  steps: [
    {
      src: step1,
      alt: 'Step 1: Table set for three with a healthy home-cooked Gousto meal ready to serve.',
      title: '1. Tell us what box size you need',
      paragraph: 'Choose between 2-5 recipes for 1-5 people.',
    },
    {
      src: step2,
      alt: 'Step 2: Person scrolling the Gousto weekly menu to pick recipes for their meal kit.',
      title: '2. Pick your recipes for the week',
      paragraph: 'Choose from 175+ weekly recipes.',
    },
    {
      src: step3,
      alt: 'Step 3: Courier leaves a Gousto recipe box at the doorstep—fresh, chilled ingredients inside.',
      title: '3. Book your delivery day',
      paragraph: 'Get fresh ingredients delivered to your door.',
    },
    {
      src: step4,
      alt: 'Step 4: Diner enjoying a Health Hub 15-minute Gousto dish—quick, balanced, and fresh.',
      title: '4. Enjoy seriously tasty meals',
      paragraph: 'Home-cooked and ready in as little as 10 minutes.',
    },
    {
      src: step5,
      alt: 'Step 5: Gousto app on a phone showing skip a box feature.',
      title: '5. No commitment',
      paragraph: 'Skip, pause or cancel whenever you like.',
    },
  ],
  ctaText: 'Unlock 50% off now',
}
